import ReactDom from "react-dom";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import PageRoutes from "../helpers/PageRoutes";
import Login from "../../pages/login/Login";
import { currentYear } from "../helpers/today";
import { useEffect, useState } from "react";
import "../../css/settings.css";
import { postData } from "../helpers/Data";
import { BrowserRouter } from "react-router-dom";
import Sales from "../../pages/Sales";

const Layout = () => {
  const [passExp, setPassExp] = useState("");
  // for allowing dropdowns functionality for now
  let hasReloaded = sessionStorage.getItem("mpos_hasReloaded");
  useEffect(() => {
    if (!hasReloaded) {
      sessionStorage.setItem("mpos_hasReloaded", "true");
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    //check if password has expired
    const frmData = new FormData();
    frmData.append("user_name", sessionStorage.getItem("mwerezi_mpos_username"));
    frmData.append("full_name", localStorage.getItem("mpos_fullname"));
    postData(frmData, "check_last_password_change")
      .then((data) => {
        if (data[0] >= 20 && data[0] < 30) {
          let days_left = 30 - data + 1;
          setPassExp(`Password expires in ${days_left} days`);
        } else {
          setPassExp("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const sales = () => {
    ReactDom.render(
      <BrowserRouter>
        <Sales />
      </BrowserRouter>,
      document.getElementById("root")
    );
  };

  const logout = () => {
    if (typeof Storage !== "undefined") {
      localStorage.removeItem("mwerezi_mpos_username");
      localStorage.removeItem("mpos_fullname");
      localStorage.removeItem("mwerezi_mpos_usergroups");
      sessionStorage.removeItem("mpos_hasReloaded");
      ReactDOM.render(<Login />, document.getElementById("root"));
    } else {
      console.log("Sorry, something went wrong, please contact admin!");
    }
  };
  return (
    <div>
      <nav
        className="main-header navbar navbar-expand navbar-white navbar-light"
        style={{ padding: "0px" }}
      >
        <ul className="navbar-nav col-md-2">
          <li className="nav-item">
            <a
              href=""
              className="nav-link"
              data-widget="pushmenu"
              role="button"
            >
              <i className="fas fa-bars"></i>
            </a>
          </li>
        </ul>
        <div className="col-md-8">
          <div className="row ">
            {/* vertical navigation for shortcuts */}
            <div className="col-md-12 brand-link" style={{ padding: "0px" }}>
              <span
                className="text-danger font-weight-bold col-md-2"
                style={{ fontSize: "12px" }}
              >
                {passExp}
              </span>
            </div>
          </div>
        </div>
      </nav>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <Link to="/" className="brand-link">
          <img
            src="/images/logo.png"
            alt="Hais"
            className="mr-4"
            height={60}
            width="auto"
            // style={{ opacity: "0.8" }}
          />
          <span className="h5 font-weight-bold text-success">MPOS</span>
        </Link>

        {/* <!-- Sidebar --> */}
        <div className="sidebar">
          <div className="user-panel">
            <div className="pl-2">
              <span style={{ color: "white", fontSize: "13px" }}>
                Welcome{" "}
                <span className="text-white">
                  {sessionStorage.getItem("mwerezi_mpos_username")}
                </span>
              </span>
            </div>
          </div>

          {/* <!-- SidebarSearch Form --> */}
          <div className="form-inline">
            <div className="input-group" data-widget="sidebar-search">
              <input
                className="form-control form-control-sidebar"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <div className="input-group-append">
                <button className="btn btn-sidebar">
                  <i className="fas fa-search fa-fw"></i>
                </button>
              </div>
            </div>
          </div>

          {/* <!-- Sidebar Menu --> */}
          <nav
            className="mt-2 overflow-auto h-100"
            id={"sidebar-wrapper"}
            style={{ maxHeight: "80%" }}
          >
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="true"
            >
              {/* <!-- Add icons to the links using the .nav-icon class */}
              {/* with font-awesome or any other icon font library --> */}
              <li className="nav-item active">
                <Link to="/" className="nav-link">
                  <i class="nav-icon fas fa-home"></i>
                  <p>HOME</p>
                </Link>
              </li>
              <li className="nav-item active">
                <Link to="/registration" className="nav-link">
                  <i class="nav-icon far fa-id-card"></i>
                  <p>CUSTOMER</p>
                </Link>
              </li>
              <li className="nav-item active">
                <Link to="/sales" className="nav-link">
                  <i class="nav-icon fas fa-hand-holding-usd"></i>
                  <p>SALES</p>
                </Link>
              </li>
              <li className="nav-item active">
                <Link to="items" className="nav-link">
                  <i class="nav-icon fas fa-cart-arrow-down"></i>
                  <p>ITEMS</p>
                </Link>
              </li>
              <li className="nav-item active">
                <Link to="stock" className="nav-link">
                  <i class="nav-icon fas fa-warehouse"></i>
                  <p>STOCK</p>
                </Link>
              </li>
              <li className="nav-item active">
                <Link to="reports" className="nav-link">
                  <i class="nav-icon fas fa-chart-line"></i>
                  <p>REPORTS</p>
                </Link>
              </li>
              <li className="nav-item active">
                <Link to="profile" className="nav-link">
                  <i class="nav-icon fas fa-user-alt"></i>
                  <p>PROFILE</p>
                </Link>
              </li>

              {/* ADMIN MODULE */}
              <li className="nav-item">
                <a href="" className="nav-link">
                  <i class="nav-icon fas fa-user-shield"></i>
                  <p>
                    ADMIN
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>

                <ul className="nav nav-treeview ml-1">
                  <li className="nav-item">
                    <Link to="add-user-group" className="nav-link">
                      <i className="far fa-circle nav-icon"></i>
                      <p>ADD USER GROUP</p>
                    </Link>
                  </li>
                </ul>
                <ul className="nav nav-treeview ml-1">
                  <li className="nav-item">
                    <Link to="add-stock" className="nav-link">
                      <i className="far fa-circle nav-icon"></i>
                      <p>ADD STOCK</p>
                    </Link>
                  </li>
                </ul>
                <ul className="nav nav-treeview ml-1">
                  <li className="nav-item">
                    <Link to="manage-user" className="nav-link">
                      <i className="far fa-circle nav-icon"></i>
                      <p>MANAGE USER</p>
                    </Link>
                  </li>
                </ul>
                <ul className="nav nav-treeview ml-1">
                  <li className="nav-item">
                    <Link to="/change-password" className="nav-link">
                      <i className="far fa-circle nav-icon"></i>
                      <p>CHANGE PASSWORD</p>
                    </Link>
                  </li>
                </ul>
                <ul className="nav nav-treeview ml-1">
                  <li className="nav-item">
                    <Link to="/audit-trails" className="nav-link">
                      <i className="far fa-circle nav-icon"></i>
                      <p>AUDIT TRAILS</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item active">
                <Link onClick={logout} className="nav-link">
                  <i class="nav-icon fas fa-sign-out-alt"></i>
                  <p>LOGOUT</p>
                </Link>
              </li>
            </ul>
          </nav>
          {/* <!-- /.sidebar-menu --> */}
        </div>
        {/* <!-- /.sidebar --> */}
      </aside>

      {/* <!-- Content Wrapper. Contains page content --> */}
      <div className="content-wrapper bg-white">
        {/* <!-- Content Header (Page header) --> */}
        <div className="content-header p-0">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <!-- find use for this line --> */}
                {/* <!-- <h1 className="m-0">Dashboard</h1> --> */}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /.content-header -->
      @yield('content')
      
      <!-- loader and overlay --> */}
        {/* MAIN DIV TO RENDER ALL PAGES */}
        <div id="main">
          <PageRoutes />
        </div>
        <div id="overlay">
          <div className="cv-spinner">
            <span className="spinner"></span>
          </div>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer">
        <strong>
          Copyright &copy; {currentYear()}{" "}
          <span className="text text-danger font-weight-bolder"> MPOS </span>
          {/* for{" "} */}
          {/* <span className="text text-primary font-weight-bolder">
            {" "}
            DEMO COMPANY.{" "}
          </span> */}
        </strong>
        <span className="font-weight-bold">
          Developed by{" "}
          <a href="https://mwerezi.co.ke">
            <span className="text text-success font-weight-bolder">
              mwerezi.co.ke
            </span>{" "}
          </a>
        </span>
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b>{" "}
          <span className="text-warning font-weight-bold">1.0.0</span>
        </div>
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>
      {/* <!-- /.control-sidebar --> */}
    </div>
  );
};

export default Layout;
